// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"17e159b0","796":"a12b5f2e"}[chunkId] + ".chunk.js";
};